import axios from "axios";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { api } from "../utils";
const initialState = {
   ActiveMachineList: [],
   ActiveMachineSuccess: true,
   ShowSides: false
};

export default function useGetActiveMachines(MachineDto, planProp, days, side = "") {
   const [data, setData] = useState(initialState);
   const Side = side;

   useEffect(() => {
      let plan = { ...planProp, StartDate: planProp.DateFrom, EndDate: planProp.DateTo, Days: days };
      const payload = { ...plan, Side: Side };
      const returnEarly = !MachineDto || typeof payload.spindlesUsed === "string" || !payload.MachineId;
      if (returnEarly) {
         setData(initialState);
         return;
      }
      const cancelToken = axios.CancelToken;
      const source = cancelToken.source();
      try {
         setData({
            ActiveMachineList: [],
            ActiveMachineSuccess: false,
            ShowSides: false
         });

         delete plan.DateFrom;
         delete plan.DateTo;
         if (!plan.MachineId) {
            toast.error("you are missing a machine id, contact your admin");
            setData({
               ActiveMachineList: [],
               ActiveMachineSuccess: true,
               ShowSides: false
            });
            return;
         }
         api
            .postS(`Production/GetActiveMachinesDropDown`, payload, source.token)
            .then((response) => {
               if (response?.data?.success) {
                  const { item1, item2 } = response.data.activeMachines
                  //item one is the boolean value, item two is the actual list, the const names are defaults in C#
                  setData({
                     ActiveMachineList: item2,
                     ActiveMachineSuccess: true,
                     ShowSides: item1
                  });
                  return;
               } else {
                  setData({
                     ActiveMachineList: [],
                     ActiveMachineSuccess: false,
                     ShowSides: false
                  });
                  return;
               }
            })
            .catch(api.catchHandler)
      } catch (error) {
         toast.error(error);
         setData({ ...data, ActiveMachineSuccess: true });
      }

      return () => {
         source.cancel("axios request cancelled");
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [MachineDto, side, planProp]);

   return data;
}
